<div class="start-page" c-main>
    <div class="top">
        <div class="triangle-space" ng-class="{hide: !showDown}">
            <div class="triangle down" ng-click="toggleSelector()" ng-show="showDown"></div>
        </div>
        <div class="widget-selectors" c-toggle="showSelector">
            <div class="col">
                <h2>{{"startPage.selector.lists" | translate}}</h2>
                <ul>
                    <li ng-repeat="widget in widgetList | filter: filterLists">
                        <div c-widget-selector="widget"></div>
                    </li>
                </ul>
            </div>
            <div class="col">
                <h2>{{"startPage.selector.misc" | translate}}</h2>
                <ul>
                    <li ng-repeat="widget in widgetList | filter: filterTools">
                        <div c-widget-selector="widget"></div>
                    </li>
                </ul>
            </div>
            <div class="triangle up" ng-click="toggleSelector()"></div>
        </div>
    </div>
    <div class="fixed-widgets">
        <ul>
            <li ng-repeat="item in widgetList  | filter: filterTools | filter: isVisible">
                <div c-widget="item"></div>
            </li>
        </ul>
    </div>
    <div class="widget-area">
        <ul c-droppable drop="onDropHandler" class="column" id="columnA">
            <li c-draggable c-droppable drop="onDropHandler" ng-repeat="item in widgetList | filter: inColumnA | filter: isVisible" class="draggable-widget" id="{{item.id}}">
                <div c-widget="item" widget-id="{{item.id}}"></div>
            </li>
        </ul>
        <ul c-droppable drop="onDropHandler" class="column" id="columnB">
            <li c-draggable c-droppable drop="onDropHandler" ng-repeat="item in widgetList | filter: inColumnB | filter: isVisible" class="draggable-widget" id="{{item.id}}">
                <div c-widget="item" widget-id="{{item.id}}"></div>
            </li>
        </ul>
    </div>
</div>
<style>
    .mobile-widgets {
        display: block;
        width: 80%;
        max-width: 450px;
        margin: 10px auto;
    }
    .mobile-widgets button {
        width: 100%;
        display: block;
        border: solid 1px rgba(0,0,0,0.25);
        background-color: rgba(0,0,0,0.05);
        padding: 10px;
        color: #808080;
    }
</style>
<div class="start-page-mobile" c-main>
    <div class="fixed-widgets">
        <ul>
            <li ng-repeat="item in widgetList | filter: filterTools | filter: isMobile">
                <div c-widget="item"></div>
            </li>
        </ul>
    </div>
    <div class="mobile-navigator">
        <div c-module-navigator class="main-menu"></div>
    </div>
    <div class="mobile-widgets">
        <button ng-if="!showingMobileWidgets" ng-click="showMobileWidgets()">{{"startPage.mobileShowWidgets"|translate}} ▼</button>
        <div class="widget-area" ng-if="showingMobileWidgets">
            <ul class="column" id="columnAmob">
                <li ng-repeat="item in widgetList | filter: inColumnA | filter: isVisible" id="{{item.id}}">
                    <div c-widget="item" widget-id="{{item.id}}"></div>
                </li>
            </ul>
            <ul class="column" id="columnBmob">
                <li ng-repeat="item in widgetList | filter: inColumnB | filter: isVisible"  id="{{item.id}}">
                    <div c-widget="item" widget-id="{{item.id}}"></div>
                </li>
            </ul>
        </div>
    </div>
</div>